import React from "react"
import Routes from "src/routes/routes"
import { withRouter } from "react-router-dom"
import ScrollToTop from "../components/ScrollToTop/ScrollToTop"
import InactivityLogout from "src/components/InactivityLogout/InactivityLogout"
import { withAITracking } from "@microsoft/applicationinsights-react-js"
import { reactPlugin } from "../AppInsights/AppInsights"
import { updateMoment } from "src/i18n/i18n"
import { datadogRum } from "@datadog/browser-rum"
import { datadogLogs } from "@datadog/browser-logs"

const App = () => {
  //updating moment with defined locale options
  updateMoment()
  const rumConfig = {
    applicationId: `${process.env.REACT_APP_DD_APP_ID}`,
    clientToken: `${process.env.REACT_APP_DD_CLIENT_TOKEN}`,
    site: `${process.env.REACT_APP_DD_SITE}`,
    env: `${process.env.REACT_APP_DD_ENV}`,
    service: `${process.env.REACT_APP_DD_SERVICE}`,
    sessionSampleRate: Number(`${process.env.REACT_APP_DD_SESSION_RATE}`),
    sessionReplaySampleRate: Number(
      `${process.env.REACT_APP_DD_SESSION_REPLAY_RATE}`
    ),
    trackResources: Boolean(`${process.env.REACT_APP_DD_TRACK_RESOURCE}`),
    trackLongTasks: Boolean(`${process.env.REACT_APP_DD_TRACK_LONG_TASK}`),
    trackUserInteractions: Boolean(`${process.env.REACT_APP_DD_USER_INTERACTION}`),
    allowedTracingUrls: [
      url => url.startsWith(process.env.REACT_APP_DD_ALLOW_TRACE_URL)
    ],
    traceSampleRate: Number(`${process.env.REACT_APP_DD_TRACE_SAMPLE_RATE}`)
  }
  console.log(rumConfig)
  console.log(`${process.env.REACT_APP_DD_ENV}`)
  console.log("rumConfig")

  datadogRum.init(rumConfig)
  datadogLogs.init({
    clientToken: `${process.env.REACT_APP_DD_CLIENT_TOKEN}`,
    site: `${process.env.REACT_APP_DD_SITE}`,
    service: `${process.env.REACT_APP_DD_SERVICE}`,
    env: `${process.env.REACT_APP_DD_ENV}`,
    forwardErrorsToLogs: true
  })
  const logWithRumContext = (message, context) => {
    const rumContext = datadogRum.getInternalContext()
    const combinedContext = {
      ...context,
      session_id: rumContext?.session_id,
      application_id: rumConfig.applicationId
    }
    datadogLogs.logger.log(message, combinedContext)
  }
  logWithRumContext("User action event", { custom_attribute: "value" })
  localStorage.setItem("isRefreshTokenInProgress", "false")

  return (
    <>
      <ScrollToTop />
      {/* istanbul ignore next */}
      <InactivityLogout />
      <Routes />
    </>
  )
}

const AppWithRouter = withRouter(App)
// export default AppWithRouter
export default withAITracking(reactPlugin, AppWithRouter)
